export enum DropdownMenuVariant {
  PRIMARY = "primary",
  DESTRUCTIVE = "destructive",
}

export interface Action<DataT> {
  id: string;
  label?: string;
  icon?: React.ElementType;
  onClick?: (item?: DataT) => void;
  variant?: DropdownMenuVariant;
  className?: string;
  getDisabled?: (item?: DataT) => boolean;
  showIf?: (item?: DataT) => boolean;
  isDivider?: boolean;
  shouldShow?: boolean;
}

export interface DropdownMenuProps<DataT> {
  menuItems: Action<DataT>[];
  icon?: React.ReactNode;
  label?: string;
  item?: DataT;
  variant?: DropdownMenuVariant;
}
